module.exports = {
  lackParameter: 'កង្វះប៉ារ៉ាម៉ែត្រ',
  emptyTxt: 'គ្មានទិន្នន័យ',
  coupon: 'គូប៉ុងរបស់ខ្ញុំ'
}